module.exports = __webpack_public_path__ + "img/u122.21aaa8bc.svg";